import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";

import { buscarComboPorCodigo } from "../../services/api-autenticacao.service";

const GenericAutoComplete = ({
  codigoCombo,
  onChange,
  selectionId,
  required = false,
  error,
  helperText,
  variant,
  ...fields
}) => {
  const [msg, setMsg] = useState("");
  const [value, setValue] = useState(null);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const [genericList, setGenericList] = useState([{}]);
  const [genericLabel, setGenericLabel] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await buscarComboPorCodigo(codigoCombo);
        const itensGenericList = await response.detalhes.itensCombo.map(
          (item) => {
            const splitValues = item.split("/|/");
            return {
              id: splitValues[0],
              label: splitValues[1],
            };
          }
        );
        setGenericList(itensGenericList);
        setGenericLabel(
          required
            ? `${response.detalhes.descricao} *`
            : response.detalhes.descricao
        );

        if (selectionId) {
          setValue(
            itensGenericList.find(
              (option) => option.id === selectionId.toString()
            )
          );
        }
      } catch (err) {
        if (err.response) {
          setMsg(err.response.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      }
    };

    fetchData();
  }, [codigoCombo]);

  const handleChange = (event, value) => {
    if (onChange) {
      onChange(value ? parseInt(value.id) : null);
      setValue(value);
    }
  };

  return (
    <div>
      <Autocomplete
        renderInput={(params) => (
          <TextField 
            label={genericLabel}
            variant={
              (variant)
                ? variant
                : "standard"
            }
            error={!!error}
            helperText={helperText}
            {...params} 
          />
        )}
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
          },
        }}
        fullWidth
        size="small"
        options={genericList}
        getOptionLabel={(option) => option.label}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
};

export default GenericAutoComplete;
